<template>
    <div id="w-full h-full">
        
        <div v-if="!layout.selectedId" class="bg-white flex flex-col h-full">

            <!-- Main Header -->
            <div v-if="!layout.loading && layout.selectedFolder" class="mx-5">
                
                <div class="rp-modal-header w-full" style="padding: 0.5rem !important">
                    <div>
                        <h2 class="text-base font-medium text-gray-600">
                            Total: 
                            <span class="rp-text-blue-2">{{ layout.crops.length }}</span> 
                            annotations 
                            <span class="rp-text-blue-2">{{ layout.selectedFolder.id }}</span>
                        </h2>
                    </div>

                    <div class="ml-auto">
                        <button
                            type="button"
                            class="rp-btn-action-secondary flex items-center space-x-1 w-auto"
                            style="flex: none; font-size: small"
                            @click="reset();">
                            <ChevronLeftIcon 
                            class="w-4 h-4" />
                            <span>{{ $t('Back') }}</span>
                        </button>
                    </div>

                </div>
            </div>

            <!-- Modifications Header -->
            <div v-if="!layout.loading && layout.selectedFolder && annotationsModified.length" class="mx-10 p-1 rp-bg-blue-4 items-center flex flex-row">
                <div class="rp-text-blue-2 w-full" style="padding: 0.5rem !important">
                    <h2 class="text-xs font-medium">
                        <span>{{ annotationsModified.length }}</span> change/s 
                    </h2>
                </div>
                
                <div class="ml-auto">
                    <button 
                        type="button"
                        class="rp-bg-blue-1 text-white px-4 py-1"
                        style="font-size: small"
                        @click="updateAnnotations();">
                        <span>{{ $t('Apply') }}</span>
                    </button>
                </div>
            </div>
            
            <div v-if="!layout.loading" class="h-full w-full p-6 overflow-y-auto">

                <!-- Folders -->
                <!-- <div v-if="!layout.selectedFolder" class="grid grid-cols-2 gap-4">
                    <div v-for="tag in filteredTags" :key="tag.id" @click="loadAnnotationsCrops(tag)"
                        class="flex flex-col items-center cursor-pointer hover:bg-gray-100 rounded-lg p-5 transition bg-white">

                        <img
                            :src="layout.folders[tag.id]?.crop || require('@/assets/images/rosepetal/icon/folder-icon.png')"
                            class="w-20 h-20 mb-2 object-cover rounded"
                        />

                        <span class="text-xs text-center">{{ tag.name }}</span>

                        <span class="text-xs font-medium text-gray-700 text-center">
                            ({{ layout.folders[tag.id]?.count || 0 }})
                        </span>

                    </div>
                </div> -->

                <!-- Folders -->
                <div v-if="!layout.selectedFolder" >
                    
                    <div v-if="Object.keys(filteredTags).length" class="grid grid-cols-3 gap-4">
                        <div v-for="tag in filteredTags" 
                            :key="tag.id"
                            @click="loadAnnotationsCrops(tag)"
                            class="box model-box shadow-none border-gray-300 hover:bg-gray-200 bg-gray-50 h-24 flex items-center justify-between cursor-pointer rounded-lg p-5 transition">

                            <!-- Contenedor izquierdo: crop + nombre -->
                            <div class="flex items-center">
                                <img
                                    :src="layout.folders[tag.id]?.crop || require('@/assets/images/rosepetal/icon/folder-icon.png')"
                                    class="w-20 h-20 object-cover rounded"
                                    alt="Crop"
                                />
                                <span class="ml-3 text-sm text-gray-800">{{ tag.name }}</span>
                            </div>

                            <!-- Contador al extremo derecho -->
                            <span class="text-sm font-medium text-gray-700">
                            ({{ layout.folders[tag.id]?.count || 0 }})
                            </span>

                        </div>
                    </div>

                    <div v-else class="text-center py-6 cursor-default box model-box shadow-none border-gray-300 bg-gray-50 flex flex-col">
                        <div class="text-sm mb-2 text-gray-600">{{$t('There are no tag types to validate')}}</div>
                        <button type="button" class="btn w-32 bg-gray-600 text-white zoom-in font-normal" @click="$emit('updateTab', 'tags')">{{ $t('Manage') }}</button>
                    </div>

                </div>

                <!-- Crops -->
                <div v-else class="grid grid-cols-5 gap-5">
                    <div v-for="(crop, index) in layout.crops" :key="index" class="col-span-1 flex items-center shadow-md zoom-in" style="height: 100%; max-height: 200px;">

                        <div class="relative group flex flex-col items-center justify-center w-full h-full bg-white rounded-lg shadow-md p-2"
                            :style="getCropBorderStyle(crop)">
                        
                            <img
                                :src="crop.cropUri"
                                alt="Cropped Annotation"
                                class="h-full w-auto object-contain cursor-pointer hover:bg-gray-100 transition"
                                @click="layout.selectedId = crop.imageId"
                            />
                    
                            <div class="absolute bottom-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                
                                <button class="rp-btn-action-primary" @click="layout.selectedCrop = crop; showAssignTag = true" style="padding: 0.25rem 0.5rem;">
                                    <Edit2Icon class="w-4 h-4"/>
                                </button>

                                <button v-if="!crop.delete" class="rp-btn-action-danger" @click="crop.delete = true" style="padding: 0.25rem 0.5rem;">
                                    <TrashIcon class="w-4 h-4"/>
                                </button>

                                <button v-else class="rp-btn-action-success" @click="crop.delete = false" style="padding: 0.25rem 0.5rem;">
                                    <ThumbsUpIcon class="w-4 h-4"/>
                                </button>

                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <div v-else class="flex-1 flex flex-col justify-center items-center text-center py-5">
                <img :src="require(`@/assets/images/rosepetal/icon/logoLoadingGray.png`)" class="w-20" />
                <LoadingIcon icon="three-dots" class="w-10 h-10 text-blue-500" />
                <p class="text-sm">{{ $t(layout.loadingMsg) }}</p>
            </div>

        </div>

        <div v-if="layout.selectedId">
            <EditorCmp 
                :options="{ id: layout.selectedId, dataset: layout.dataset, datasetsList: layout.datasetsList }"
                @closeEditor="layout.selectedId = false"/>
        </div>

        <div v-if="showAssignTag">
            <AssignTagCmp 
                :dataset="layout.dataset"
                :crop="layout.selectedCrop"
                :cropsMap="layout.cropsMap"
                @closeModal="layout.cropId = false; showAssignTag = false;"/>
        </div>

    </div>
</template>

<script setup>
import { onMounted, onUnmounted, computed, ref } from "vue";

import EditorCmp    from "@/components/manage-image/Editor.vue";
import AssignTagCmp from "@/modals/tag/AssignTag.vue";

import * as rosepetalModel  from "rosepetal-model";
import config 				from '@/etc/rosepetal.json';

const $emit = defineEmits(['updateDataset']);

const $dataset  = rosepetalModel.default.dataset;
const $image    = rosepetalModel.default.image;

const props = defineProps({
    dataset: {
		type: Object,
		required: true
	},
    datasetsList: {
        type: Array,
        required: false
    }
});

const filteredTags = computed(() => {
    let tags = {};
    
    if (layout.value.dataset && layout.value.dataset.tags) {
        switch (layout.value.dataset.type) {
            case 'MULTICLASS':
                tags = Object.values(layout.value.dataset.tags);
                break;
            case 'MULTILABEL':
                tags = Object.fromEntries(
                    Object.entries(layout.value.dataset.tags)
                          .filter(([_, tag]) => !tag?.normal && tag?.id !== '0')
                );
                break;
            case 'imageObjectDetection':
                tags = Object.fromEntries(
                    Object.entries(layout.value.dataset.tags)
                          .filter(([_, tag]) => !tag?.unclassified)
                );
                break;
            default:
                tags = {};
        }
    }
    
    return tags;
});

const annotationsModified = computed(() => {
    if (layout.value.crops && layout.value.crops.length > 0) {
        return layout.value.crops.filter(crop => crop.modified || crop.delete);
    }
    return [];
});

const annotationsNotModified = computed(() => {
    if (layout.value.crops && layout.value.crops.length > 0) {
        return layout.value.crops.filter(crop => !crop.modified && !crop.delete);
    }
    return [];
});

const showAssignTag = ref(false);

const layout = ref({
	dataset:        false,
	loading:        false,
    loadingMsg:     false,
    selectedFolder: false,
    folders:        {},
    crops:          [],
    cropsMap:       [],
    selectedId:     false,
    selectedCrop:   false
});

const fetchController = ref(null);

const loadAnnotationsCounts = async () => {
    layout.value.loading = true;
    layout.value.loadingMsg = 'Loading folders…';

    const counts = await $dataset.getAnnotationsCounts(layout.value.dataset, filteredTags.value);
    layout.value.folders = {};

    const tagIds = Object.keys(filteredTags.value);

    const folderPromises = tagIds.map(async (tagId) => {
        const count = counts[tagId] || 0;

        const [image] = await $dataset.getImagesTagmap(layout.value.dataset, [tagId], 1);
        let crop = null;

        if (image) {
            crop = await cropImageForTag(image, tagId);
        }

        return {
            tagId,
            data: {
                count,
                crop,
            },
        };
    });

    const foldersData = await Promise.all(folderPromises);

    for (const { tagId, data } of foldersData) {
        layout.value.folders[tagId] = data;
    }

    layout.value.loading = false;
}

const cropImageForTag = async (image, tagId) => {
    const box = image.tags.find(t => t.tag?.id === tagId && t.type === 'rect');
    if (!box) return null;

    return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const cropX = box.x * img.width;
            const cropY = box.y * img.height;
            const cropW = box.w * img.width;
            const cropH = box.h * img.height;

            canvas.width = cropW;
            canvas.height = cropH;
            ctx.drawImage(img, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);

            resolve(canvas.toDataURL('image/jpeg'));
        };
        img.onerror = () => resolve(null);

        img.src = image.imageData.reducedImg || image.imageData.originalImg;
    });
}

const loadAnnotationsCrops = async (tag) => {
    if (fetchController.value) {
        fetchController.value.abort();
    }

    const controller = new AbortController();
    fetchController.value = controller;

    layout.value.loading = true;
    layout.value.loadingMsg = 'Loading annotations…';
    layout.value.selectedFolder = tag;

    const crops = await $dataset.getAnnotationsCrops(
        layout.value.dataset,
        layout.value.selectedFolder.id,
        config.functions.usapi,
        controller
    );

    
    if (crops.status === "cancelled") {
        layout.value.loading = false;
        return;
    }

    layout.value.crops = crops;

    layout.value.loading = false;
}

const getCropBorderStyle = (crop) => {
    if (crop.delete) {
        return 'border: 3px solid #dc2626';
    }

    if (layout.value.selectedFolder && crop.id !== layout.value.selectedFolder.id) {
        return 'border: 3px solid #17356e';
    }
    return '';
}

const updateAnnotations = async () => {
    layout.value.loading = true;
    layout.value.loadingMsg = 'Updating annotations…';

    const groupedCrops = {};
    for (const crop of annotationsModified.value) {
        if (!groupedCrops[crop.imageId]) {
            groupedCrops[crop.imageId] = [];
        }
        groupedCrops[crop.imageId].push(crop);
    }

    await $image.updateAnnotations(layout.value.dataset, groupedCrops);
    layout.value.crops = annotationsNotModified.value;

    layout.value.loading = false;
}

const reset = async () => {
    if (fetchController.value) {
        fetchController.value.abort();
    }

    layout.value.selectedFolder = false;
    layout.value.selectedId     = false;
    layout.value.loading        = false;
    layout.value.crops          = [];

    loadAnnotationsCounts();
}

onMounted(async () => { 
	if (props.dataset) {
        if (props.datasetsList) {
            layout.value.datasetsList = props.datasetsList;
        }

		layout.value.dataset = props.dataset;
		await loadAnnotationsCounts();
	}
});

onUnmounted(() => {
    if (fetchController.value) {
        fetchController.value.abort();
    }
});
</script>